import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './util/i18n'
import { changeLanguage } from './util/lang'

Vue.prototype.$changeLanguage = changeLanguage;

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.config.productionTip = false

// 后台图片地址
Vue.prototype.$baseUrl = '/prod-api';
// Vue.prototype.$baseUrl = 'http://127.0.0.1:9085';

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')

// 监听语言变化
window.addEventListener('languageChanged', () => {
  const lang = localStorage.getItem('lang');
  i18n.locale = lang;
});
